import { render } from "./MessageBody.vue?vue&type=template&id=2f548b0a&scoped=true"
import script from "./MessageBody.vue?vue&type=script&lang=js"
export * from "./MessageBody.vue?vue&type=script&lang=js"

import "./MessageBody.vue?vue&type=style&index=0&id=2f548b0a&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-2f548b0a"

export default script